import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import GenericModal from '../../GenericModal'
import { connect } from 'react-redux'
import classNames from 'classnames';
import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'


const Content = styled.div`

  padding: 16px 20px 17px 20px;

  h3 {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;

    color: #666666;
    line-height: 16px;
    margin: 0px;
    padding: 0px;
  }

  p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
    margin: 0px;
    padding: 0px;
    margin-top: 6px;
  }

  .current-method {
    color: #666666;
    background: #EDEDED;
    padding: 11px 16px;
    margin-top: 9px;
    display: block;
  }

  > button {
    height: 43px;
    width: 100%;
    margin-top: 15px;
  }

  > div {
    border-top: 1px dashed #CCCCCC;
    margin-top: 21px;
    padding-top: 16px;

    a {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #1D71BB;
      line-height: 16px;
      text-decoration: none;
      margin-top: 7px;
      display: block;
    }
  }

  .disableClick{
      pointer-events: none;
      color: #BBBBBB;
  }
`

export class TaxElectionsDialog extends Component {

  onChangeTaxPayment = (callback) => {
    this.props.onChangeTaxPayment()
  }

  onChangeTaxPaymentBroker = () => {
    var brokerUrl = employeeService.getEmployeeBrokerUrl(this.props.employee)

    if(this.props.employee.broker && brokerUrl && this.props.employee.broker !== '') {
      var win = window.open(brokerUrl, '_blank');
      win.focus();
      this.props.onCloseDialog()
    }
  }

  render() {
    
    if (!this.props.visible) {
      return null;
    }

    const { t, employee, awardIdSelected, calendarYear, vest } = this.props;
    const buttonDisabled = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_DISABLE)

    var taxEnable = !employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_HIDE)

    if(awardIdSelected) {

      const award = employeeService.loadAward(employee.awards, awardIdSelected)
      if(award && !award.has_us_sourcing_in) {
          taxEnable = false
      }
    } else {
      // I need to verufy if there is any possible award to apply the tax rate change
      const awards_to_apply_tax =  employeeService.getAwardsForTaxElection(employee.awards).filter((el) => !el.fully_vested)

      if(!awards_to_apply_tax || awards_to_apply_tax.length <= 0 ) {
        taxEnable = false
      }
    }

    var classNamesForTax = classNames({
      'disableClick': buttonDisabled,
      'change-us-federal-tax-rate': true
    });
    let methods = ''

    if (vest) {
      methods = t(`TaxTreatment.${vest.tax_election.code}`)
    } else {
      methods = employeeService.getPaymentMethods(employee.awards, awardIdSelected, calendarYear)
        .map(taxElectionCode => t(`TaxTreatment.${taxElectionCode}`))
        .join(', ')
    }

    let taxElectionsEmail = t('TaxElectionsDialog.TaxElectionEmailNoAPS')
    if (employeeService.isZooxEmployee(employee)){
      taxElectionsEmail = t('TaxElectionsDialog.TaxElectionEmailZoox')
    }

    return (
      <GenericModal
        title={t('TaxElectionsDialog.Title')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="tax-elections"
      >
        <Content>
          <h3>{t('TaxElectionsDialog.TaxPaymentMethod')}</h3>
          <p>{t('TaxElectionsDialog.SeeHow')}</p>
          <p className="current-method">{t('TaxElectionsDialog.CurrentMethod')}: {methods}</p>
          {  !employeeService.isBrokerChoiceNone(employee) &&
            <React.Fragment>
              {  !employeeService.isAPSEmployee(employee) &&
                <div>
                  <button className="primary-button change-tax-payment" onClick={this.onChangeTaxPaymentBroker}>{t('TaxElectionsDialog.ChangeTax')}</button>
                  <p dangerouslySetInnerHTML={{ __html: t('TaxElectionsDialog.TaxElectionMessageNoAPS') }}></p>
                  <p dangerouslySetInnerHTML={{ __html: taxElectionsEmail }}></p>
                </div>
              }
              {  employeeService.isAPSEmployee(employee) &&
                <div>
                  <button className="primary-button change-tax-payment" onClick={this.onChangeTaxPaymentBroker}>{t('TaxElectionsDialog.ChangeTax')}</button>
                  <p dangerouslySetInnerHTML={{ __html: t('TaxElectionsDialog.TaxElectionMessage') }}></p>
                </div>
              }
            </React.Fragment>
          }

          { taxEnable &&
            <div>
              <h3>{t('TaxElectionsDialog.USFederalTaxRate')}</h3>
              <p>{t('TaxElectionsDialog.IfYouNeed')}</p>
              <a className={classNamesForTax} onClick={this.onChangeTaxPayment} href="#/" >{t('TaxElectionsDialog.ChangeUSFederalTaxRate')}</a>
              { !employeeService.isWholeFoodsEmployee(employee) && !employeeService.isZooxEmployee(employee) &&
                <span>
                  <p dangerouslySetInnerHTML={{ __html: t('TaxElectionsDialog.PreclearanceToolText') }}></p>
                  <a target="_blank" href={process.env.REACT_APP_PRECLEAR} >{t('TaxElectionsDialog.PreclearanceToolLink')}</a>
                </span>
              }

              { (employeeService.isWholeFoodsEmployee(employee) || employeeService.isZooxEmployee(employee)) &&
                  <p dangerouslySetInnerHTML={{ __html: t('TaxElectionsDialog.PreclearanceWholeFoodsText') }}></p>
              }

            </div>
          }

        </Content>
      </GenericModal>
    )
  }
}

const mapState = state => ({
  employee: state.employee
})

export default connect(mapState)(withTranslation('translations')(TaxElectionsDialog))

